<template>
  <div class="home-container">
    <div class="hx-breadcrumb">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item>首页</el-breadcrumb-item>
        <el-breadcrumb-item>供应系统</el-breadcrumb-item>
        <el-breadcrumb-item>基地管理</el-breadcrumb-item>
        <el-breadcrumb-item>基地养殖数据</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <hx-table-result
      :page-info="pager"
      :loading="tableLoading"
      @page-current-change="handleCurrentChange"
      @page-size-change="handleSizeChange"
    >
      <div slot="action"></div>

      <hx-table-result-col>
        <div class="wrap-table-info-display">
          <el-button
            class="align-left"
            type="primary"
            size="small"
            @click="toCreate"
          >
            新增
          </el-button>

          <span class="table-info-display">
            <span>总条数：</span>
            <span class="alert-text ft16">{{ pager.total }}</span>
          </span>
        </div>
      </hx-table-result-col>

      <el-table slot="content" :data="tableData" max-height="800" border>
        <el-table-column align="center" width="60" label="序号">
          <template slot-scope="scope">
            <span
              v-text="
                (pager.pageIndex > 1
                  ? (pager.pageIndex - 1) * pager.pageSize
                  : 0) +
                  scope.$index +
                  1
              "
            >
            </span>
          </template>
        </el-table-column>

        <el-table-column prop="title" align="center" label="基地名称">
        </el-table-column>

        <el-table-column prop="address" align="center" label="品种">
        </el-table-column>

        <el-table-column prop="sort" align="center" label="品名">
        </el-table-column>

        <el-table-column prop="sort" align="center" label="养殖规模">
          <el-table-column prop="sort" align="center" label="生产期数量">
          </el-table-column>
          <el-table-column prop="sort" align="center" label="后备数量">
          </el-table-column>
        </el-table-column>

        <el-table-column prop="sort" align="center" label="养殖面积">
        </el-table-column>

        <el-table-column prop="sort" align="center" label="供应开始时间">
        </el-table-column>

        <el-table-column prop="sort" align="center" label="供应次数">
        </el-table-column>

        <el-table-column prop="sort" align="center" label="次供应产量">
        </el-table-column>

        <el-table-column prop="sort" align="center" label="总产量">
        </el-table-column>
      </el-table>
    </hx-table-result>
  </div>
</template>

<script>
export default {
  data() {
    return {
      tableLoading: false,
      tableData: [],
      pager: {
        pageIndex: 1,
        pageSize: 15,
        total: 0
      },
      dialogTitle: "",
      dialogVisible: false,
      isDisabled: false,
      method: "",
      url: "",
      itemParams: {
        title: "",
        address: "",
        sort: 1,
        supplyId: 200
      },
      checkItemParams: {
        title: [{ required: true, message: "请输入基地名称", trigger: "blur" }],
        address: [
          { required: true, message: "请输入基地名称", trigger: "blur" }
        ],
        sort: [{ required: true, message: "请输入序号", trigger: "change" }]
      }
    };
  },
  mounted() {
    this.loadTableData();
  },
  methods: {
    /**
     * 加载列表数据
     */
    loadTableData() {},
    /**
     * 新增基地列表
     */
    toCreate() {},
    handleCurrentChange(val) {
      this.pager.pageIndex = val;
      this.loadTableData();
    },
    /**
     * pageSize的change事件
     * @param val
     */
    handleSizeChange(val) {
      this.pager.pageSize = val;
      this.loadTableData();
    }
  }
};
</script>

<style lang="less" scoped>
.home-container {
  .alert-text {
    color: #e9a021;
    cursor: default;
  }
}
</style>
